export enum DATA_VALIDATTION_STAGE {
	DATA_VALIDATION_VALID_STATUS = 'valid',
	DATA_VALIDATION_INVALID_STATUS = 'invalid',
	DATA_VALIDATION_DUPLICATE_STATUS = 'duplicates',
	DATA_VALIDATION_ALL_STATUS = 'all',
}

export enum BANNER_TITLE {
	BANNER_MAIN_TITLE = 'Data ingestion',
	BANNER_SUB_HEADING = 'Quickly load your user, policy, process, and control data through our intuitive data upload workflow.',
}

export enum BUTTON_TEXT {
	REGENERATE = 'Regenerate',
	SAVE = 'Save',
}

export enum DATAINGESTIONTABS {
	ALL = 'All',
	PROCESSING = 'Processing',
	VALIDATING = 'Validating',
	FAILED = 'Failed',
	COMPLETED = 'Completed',
}
export const SHOW_ONLY_UPLOADED_BY_ME = 'Show only uploaded by me';
export const FILE_UPLOAD_TITLE_TEXT = 'File upload';
export const FILE_UPLOAD_DATA_TYPE_TEXT = 'Select the data type';
export const UPLOAD_YOUR_FILE_TEXT = 'Upload your file';
export const SUPPORTED_FILES_TEXT_EXCEL = 'csv or xlsx';
export const SUPPORTED_FILES_TEXT_PDF = 'pdf';
export const FILE_ALREADY_EXISTS_ERROR_MESSAGE = 'File already exists';

export enum FILTER_KEYS {
	STATUS = 'status',
}

export const UPLOAD_FILE_TYPES = [
	{
		label: 'Excel',
		value: 'excel',
	},
	{
		label: 'PDF',
		value: 'pdf',
	},
	{
		label: 'HTML',
		value: 'html',
	},
];

export enum DATA_INGESTION_RELATION_MAPPING_TAB_VALUES {
	PROCESSES = 'Processes',
	RISKS = 'Risks',
	CONTROLS = 'Controls',
	POLICIES = 'Policies',
	POLICY = 'Policy',
	PRC_MAPPING = 'PRC mapping',
	RELATION_MAPPING_TEXT_VALUE = 'relationship_mapping',
}

export const REGULATIONS = 'Regulations';
export const REGULATIONS_UPLOAD_TEXT =
	'Since the data type is regulation, the user may need to follow multiple steps to parse the file after it is uploaded.';
export const PARSE_REGULATION_LABEL = 'Parse regulation';

export const DATA_INGESTION_LABEL = 'Data ingestion';
